import { useAuth } from "@/app/providers";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import { useState } from "react";

export function LoginPage() {
  const { loginWithGoogleCallBack } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleGoogleSuccess = async (credentialResponse: CredentialResponse) => {
    if (!credentialResponse.credential) {
      setError("Google 로그인에 실패했습니다.");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      // credential은 JWT ID token입니다
      await loginWithGoogleCallBack(credentialResponse.credential);
    } catch (err) {
      console.error("로그인 실패:", err);
      setError("로그인에 실패했습니다. 다시 시도해주세요.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    setError("Google 로그인에 실패했습니다.");
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <Card className="min-w-[400px] min-h-[380px] max-w-md flex flex-col justify-between">
        <CardHeader className="flex-shrink-0 pt-[15%] pb-[10%] text-center space-y-6">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-lg">
            <img src="/prism_logo.png" alt="Prism BackOffice" className="h-16 w-16 object-contain" />
          </div>
          <CardTitle className="text-3xl font-bold">Prism BackOffice</CardTitle>
        </CardHeader>

        <CardContent className="flex-1 flex flex-col justify-center space-y-6">
          {error && (
            <div className="rounded-md bg-destructive/10 p-3 text-sm text-destructive">
              {error}
            </div>
          )}

          <div className="flex flex-col items-center">
            {isLoading ? (
              <div className="flex items-center justify-center w-full h-12">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
                <span className="ml-2 text-sm text-muted-foreground">로그인 중...</span>
              </div>
            ) : (
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleError}
                auto_select={false}
                theme="filled_blue"
                size="large"
                text="signin_with"
                width="240"
                ux_mode="popup"
              />
            )}
          </div>

          <div className="text-center text-sm text-muted-foreground">
            <p>Google 계정으로 로그인하세요</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}